<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="520px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title class="text-h5">
              <!-- {{ title }} -->
              Add Bank
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Bank Name*"
                      v-model="form.name"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Bank Code*"
                      v-model="form.code"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Account Name*"
                      v-model="form.accountName"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Account Number*"
                      v-model="form.accountNumber"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="accountTypes"
                      label="Account Type*"
                      :rules="rules.required"
                      v-model="form.accountType"
                    ></v-select>
                  </v-col>

                  <!-- <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Mobile Number*"
                      v-model="form.mobileNumber"
                      v-mask="'+63 ### #### ###'"
                      masked="false"
                      type="tel"
                      placeholder="+63 XXX XXXX XXX"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col> -->
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>

            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn @click.native="cancel">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-col>
    <Snackbar />
  </v-row>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import Snackbar from "../Snackbar.vue";

export default {
  mixins: [ShareableMethods],
  name: "AddBankDialog",
  components: { Snackbar },
  data() {
    return {
      accountTypes: ["Savings", "Current", "NA"],
      // dealerTypes: ["Dealer", "Internal Dealer", "Dealer MSA", "Dealer MSP"],
      exportData: [],
      fileName: "",

      dialog: false,
      resolve: null,
      reject: null,
      // message: null,
      // title: null,
      // options: {
      //   color: "grey lighten-3",
      //   width: 400,
      //   zIndex: 200,
      //   noconfirm: false,
      // },

      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        code: "",
        name: "",
        distributorId: "",
        accountNumber: "",
        accountName: "",
        accountType: "",
        // mobileNumber: "",
        addedBy: "",
      },
      loadingBtn: false,
    };
  },

  methods: {
    open() {
      this.dialog = true;
      // this.getRetailerSales(data.retailerId);
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      const { adminLogin } = this.userData;
      this.loadingBtn = true;
      let data = this.form;

      // data.mobileNumber = this.trimMobileNumber(data.mobileNumber);
      data.addedBy = adminLogin.name;
      data.distributorId = adminLogin.distributorId;

      // console.log(data)

      await this.$drs
        .post("/broker/drs/distributor-banks", data)
        .then((response) => {
          const res = response.data;
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.loadingBtn = false;

          if (res.status) {
            this.$refs.form.reset();
            this.agree();
          }
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },
  },

  created() {},

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
